export const GET_REPORTS_LIST_ACTION = "GET_REPORTS_LIST_ACTION"
export const GET_REPORTS_LOADING = "GET_REPORTS_LOADING"
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS"
export const GET_REPORTS_ERROR = "GET_REPORTS_ERROR"
export const DOWNLOAD_REPORTS_LIST_ACTION = "DOWNLOAD_REPORTS_LIST_ACTION";
export const DOWNLOAD_REPORTS_LIST_START = "DOWNLOAD_REPORTS_LIST_START";
export const DOWNLOAD_REPORTS_LIST_COMPLETE = "DOWNLOAD_REPORTS_LIST_COMPLETE";

// ── /reports/* analysis endpoints ────────────────────────────────────────
// One family per endpoint. Follows the ACTION / LOADING / SUCCESS / ERROR
// convention used across dashboard/companyDashboard/campaigns/engagement.
export const CLIENT_ANALYSIS_ACTION = "CLIENT_ANALYSIS_ACTION";
export const CLIENT_ANALYSIS_LOADING = "CLIENT_ANALYSIS_LOADING";
export const CLIENT_ANALYSIS_SUCCESS = "CLIENT_ANALYSIS_SUCCESS";
export const CLIENT_ANALYSIS_ERROR = "CLIENT_ANALYSIS_ERROR";

export const REVENUE_ANALYSIS_ACTION = "REVENUE_ANALYSIS_ACTION";
export const REVENUE_ANALYSIS_LOADING = "REVENUE_ANALYSIS_LOADING";
export const REVENUE_ANALYSIS_SUCCESS = "REVENUE_ANALYSIS_SUCCESS";
export const REVENUE_ANALYSIS_ERROR = "REVENUE_ANALYSIS_ERROR";

export const TRANSACTION_ANALYSIS_ACTION = "TRANSACTION_ANALYSIS_ACTION";
export const TRANSACTION_ANALYSIS_LOADING = "TRANSACTION_ANALYSIS_LOADING";
export const TRANSACTION_ANALYSIS_SUCCESS = "TRANSACTION_ANALYSIS_SUCCESS";
export const TRANSACTION_ANALYSIS_ERROR = "TRANSACTION_ANALYSIS_ERROR";

export const USER_STATS_ACTION = "USER_STATS_ACTION";
export const USER_STATS_LOADING = "USER_STATS_LOADING";
export const USER_STATS_SUCCESS = "USER_STATS_SUCCESS";
export const USER_STATS_ERROR = "USER_STATS_ERROR";

export const SALARY_REVENUE_ANALYSIS_ACTION = "SALARY_REVENUE_ANALYSIS_ACTION";
export const SALARY_REVENUE_ANALYSIS_LOADING = "SALARY_REVENUE_ANALYSIS_LOADING";
export const SALARY_REVENUE_ANALYSIS_SUCCESS = "SALARY_REVENUE_ANALYSIS_SUCCESS";
export const SALARY_REVENUE_ANALYSIS_ERROR = "SALARY_REVENUE_ANALYSIS_ERROR";

export const COMPANY_ANALYSIS_ACTION = "COMPANY_ANALYSIS_ACTION";
export const COMPANY_ANALYSIS_LOADING = "COMPANY_ANALYSIS_LOADING";
export const COMPANY_ANALYSIS_SUCCESS = "COMPANY_ANALYSIS_SUCCESS";
export const COMPANY_ANALYSIS_ERROR = "COMPANY_ANALYSIS_ERROR";

// Clear a single report's error+fieldErrors (used when the operator changes a
// filter and the previous 400 shouldn't linger).
export const RESET_ANALYSIS_ERROR = "RESET_ANALYSIS_ERROR";